export enum FeatureFlag {
  Releases = 'releases',
  MultiChannelNotifications = 'multi-channel-notifications',
  HcpExpansionWorkspace = 'hcp-expansion-workspace',
  DtcWorkspace = 'dtc-workspace',
  StudioAI = 'studio-ai',
  SmartSearch = 'studio-ai-search',
  DtcAudienceRequestLimit = 'dtc-audience-request-limit',
  DtcReporting = 'dtc-reporting',
  HCPNewInsuranceVisType = 'hcp-new-insurance-vis-type',
  IqviaMediaEffectiveness = 'iqvia-media-effectiveness',
}
